import { render, staticRenderFns } from "./DocFile.vue?vue&type=template&id=1ca9a70e"
import script from "./DocFile.vue?vue&type=script&lang=js"
export * from "./DocFile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports